// extracted by mini-css-extract-plugin
export default {"drawIn":"Doodle_drawIn__IJ4fp","drawStroke":"Doodle_drawStroke__LC8ki","fadeInDot":"Doodle_fadeInDot__G4-3n"};